// noinspection JSIgnoredPromiseFromCall

import { catchError } from 'rxjs/operators';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';

/**
 * Lightweight interceptor that works alongside MSAL's interceptor
 * Only handles token blocklist detection - MSAL handles token management
 */
@Injectable()
export class TokenBlocklistInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private msalService = inject(MsalService);

  constructor() {
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
  }


  /* Services */


  /* Member Vars */

  private serviceConfig: ServiceConfig;


  /* Lifecycle Hooks */


  /* Interface Methods */

  /**
   * Intercept HTTP requests to handle token blocklist errors
   * @param req The outgoing HTTP request
   * @param next The next handler in the chain
   * @returns An observable of the HTTP event
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error))
    );
  }


  /* Instance Methods */

  /**
   * Handle HTTP errors, specifically looking for our custom blocked token error
   * @param error The HTTP error response
   * @returns An observable that throws the error if it's not the blocked token error
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    // Only handle our specific blocked token error
    if (error.status === 401 && error.error?.error === 'token_blocked') {
      console.warn('Token has been blocked by the server');
      this.handleTokenBlockedError();
    }

    // Let all other errors pass through (including other 401s that MSAL should handle)
    return throwError(() => error);
  }

  /**
   * Handle the blocked token error by clearing the MSAL cache and redirecting
   * to the logout or home page as configured in the service config
   */
  private handleTokenBlockedError(): void {
    console.warn('Token has been blocked - clearing authentication state');

    // Clear MSAL cache
    this.msalService.instance.clearCache();

    // Navigate to log in/home
    this.router.navigate([ this.serviceConfig.logoutRedirectUrl ]);
  }
}
